import { omit } from "lodash";
import type { SearchDataModel } from "@/entities/data-model";
import { FormLevelFeatureType } from "@/entities/form-metadata";
import type { FormLevelFeature } from "@/entities/form-metadata";
import type { FormValues } from "../form";

/**
 * Maps timespan form values to the data model representation for serialization.
 * Nulls out yearStart/yearEnd when they match the slider defaults (full range)
 * so they are not included in the search URL.
 */
export function mapTimespanToDataModel(
    timespan: FormValues["timespan"],
    features: FormLevelFeature[],
): SearchDataModel["timespan"] {
    const defaultTimespan: SearchDataModel["timespan"] = {
        yearStart: null,
        yearEnd: null,
        matchMode: "rankOnly",
    };
    if (!timespan.isVisible) return defaultTimespan;

    const timespanFeature = features.find((f) => f.featureType === FormLevelFeatureType.Timespan);
    if (!timespanFeature) return defaultTimespan;

    const { min, max } = timespanFeature.attributes.sliderRange;
    if (timespan.yearStart === min && timespan.yearEnd === max) {
        return defaultTimespan;
    }

    return omit(timespan, "isVisible");
}
